import React, { useContext, useEffect, useState, } from 'react';
// import { useNavigate } from 'react-router-dom';
import { serverUrl, BRANCH } from '../../Constant/Static/config';
import prevIcon from '../../Constant/Icons/leftarrow.svg';
import nextIcon from '../../Constant/Icons/rightarrow.svg';
import axios from 'axios';
import { AuthContext } from '../../Auth/AuthContext';
import Loader from '../../Constant/Custom/Loader';
import PopModal from '../../Constant/Custom/Models/PopModal';

function Choicefilling({ handleNext }) {
  const { auth } = useContext(AuthContext);

  const sex = localStorage.getItem('sex');
  // const sex="Male";
  const storedUser = auth.user;
  const [selectedChoices, setSelectedChoices] = useState([]);
  const [csrfToken, setCsrfToken] = useState('');
  const [data, setData] = useState([]);
  const [community, setCommunity] = useState('')
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [selectedCollege, setSelectedCollege] = useState('');
  const [colleges, setColleges] = useState([]);
  const [selectedDept, setSelectedDept] = useState('');
  const [depts, setDepts] = useState([]);
  const [selectedDist, setSelectedDist] = useState('');
  const [dist, setDist] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ icon: '', title: '', text: '' });
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [onCancel, setOnCancel] = useState(() => () => { });
  const [pendingChoice, setPendingChoice] = useState(null);
  const [clearFilter, setClearFilter] = useState(false)

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setShowCancelButton(false);
    setPendingChoice(null);
    setOnConfirm(() => () => { });
    setOnCancel(() => () => { });
  };

  const [filterData, setFilterData] = useState({
    university: false,
    government: false,
    governmentAided: false,
    cipetCsir: false,
    womenColleges: false,
    selfFinanceColleges: false
  });
  const hanleSelectedChoices = () => {
    handleNext();

  }
  const handleFilter = (event) => {
    // console.log(event.name)
    setLoading(false);
    const { name, checked } = event.target;
    setFilterData((prev) => ({ ...prev, [name]: checked }));
  };

  const handleCollegeChange = (event) => {
    setSelectedCollege(event.target.value);
    setLoading(false);
  };

  const handleDeptChange = (event) => {
    setSelectedDept(event.target.value);
    setLoading(false);
  };

  const handleDistChange = (event) => {
    setSelectedDist(event.target.value);
    setLoading(false);
  };

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, { withCredentials: true });
        setCsrfToken(response.data.csrfToken);
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    fetchCsrfToken();
  }, []);


  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const retrieveWomensCollege = localStorage.getItem('sex') !== "Male";
      // console.log(localStorage.getItem('sex'),retrieveWomensCollege);

      const response = await axios.post(
        `${serverUrl}/api/choicefilling/user/choices/available`,
        { page, pageSize, retrieveWomensCollege },
        {
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken
          },
          withCredentials: true
        }
      );


      setData(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      setError(error.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  const retrieveChoicesWithCommunity = async () => {
    setLoading(true);
    setError(null);

    try {
      const encryptedData = btoa(JSON.stringify({ storedUser }));  // Encrypt the data before sending
      const response = await axios.post(
        `${serverUrl}/api/choicefilling/user/choices/retrieve`,
        { data: encryptedData },
        {
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken
          },
          withCredentials: true
        }
      );
      // console.log(response);
      const formattedChoices = response.data.choices.map(choice => {
        const [COLL_CODE, BRANCH] = choice.match(/(\d+)([A-Z]+)/).slice(1, 3);
        return { COLL_CODE, BRANCH };
      });
      setSelectedChoices(formattedChoices);
      setCommunity(response.data.comm);
    } catch (error) {
      setError(error.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!csrfToken) return;
    fetchData();
  }, [csrfToken, page, pageSize]);

  useEffect(() => {
    if (!csrfToken) return;
    retrieveChoicesWithCommunity();
  }, [csrfToken]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const handleCheckbox = async (COLL_CODE, BRANCH) => {
    // console.log(filterData.womenColleges);
    // console.log(sex)
    const womensCollegeCode = ['1605', '2620', '2638', '2643', '2661', '3852', '4944'];
    const isSelected = selectedChoices.some(
      (choice) =>
        String(choice.COLL_CODE) === COLL_CODE && String(choice.BRANCH) === BRANCH
    );
    if (womensCollegeCode.includes(COLL_CODE) && sex === "Male") {
      setPendingChoice({ COLL_CODE, BRANCH });
      setModalType({
        icon: 'info',
        title: 'Invalid Selection...!',
        text: `You are not able to add the women's college to your choice list`,
      });

      setOnConfirm(() => () => {
        closeModal();
      });

      openModal();

    }



    else if (isSelected) {

      setPendingChoice({ COLL_CODE, BRANCH });
      setModalType({
        icon: 'warning',
        title: 'Confirm Removal',
        text: `Do you want to remove this choice: <b style="font-weight:900">${COLL_CODE} - ${BRANCH}</b> ?`,
      });
      setShowCancelButton(true);
      setOnConfirm(() => () => confirmRemoveChoice(COLL_CODE, BRANCH));
      setOnCancel(() => closeModal);
      openModal();
    } else {

      setPendingChoice({ COLL_CODE, BRANCH });
      setModalType({
        icon: 'info',
        title: 'Confirm Addition',
        text: `Do you want to add <b style="font-weight:900">${COLL_CODE} - ${BRANCH}</b> to your choices?`,
      });
      setShowCancelButton(true);
      setOnConfirm(() => () => confirmAddChoice(COLL_CODE, BRANCH));
      setOnCancel(() => closeModal);
      openModal();
    }
  };

  const confirmAddChoice = async (COLL_CODE, BRANCH) => {
    try {
      setIsModalOpen(false)
      setLoading(true)
      const encryptedData = btoa(JSON.stringify({ storedUser, COLL_CODE, BRANCH }));

      await axios.post(
        `${serverUrl}/api/choicefilling/user/choices/addchoice`,
        { data: encryptedData },
        {
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken,
          },
          withCredentials: true,
        }
      );

      setSelectedChoices((prev) => [...prev, { COLL_CODE, BRANCH }]);
      setLoading(false);



      closeModal();
      setModalType({
        icon: 'success',
        title: 'Choice Added',
        text: `The choice <b style="font-weight:900">${COLL_CODE} - ${BRANCH}</b> was added successfully.`,
      });
      setShowCancelButton(false);
      setOnConfirm(() => closeModal);
      setOnCancel(() => () => { });
      openModal();
    } catch (error) {
      console.error('Error adding choice:', error);
      closeModal();
      setModalType({
        icon: 'error',
        title: 'Addition Failed',
        text: 'Something went wrong while adding your choice.',
      });
      setShowCancelButton(false);
      setOnConfirm(() => closeModal);
      setOnCancel(() => () => { });
      openModal();
    } finally {
      setPendingChoice(null);
      setLoading(false)
    }
  };

  const confirmRemoveChoice = async (COLL_CODE, BRANCH) => {
    try {

      const encryptedData = btoa(JSON.stringify({ storedUser, COLL_CODE, BRANCH }));
      closeModal();
      setLoading(true)
      await axios.post(
        `${serverUrl}/api/choicefilling/user/choices/removechoice`,
        { data: encryptedData },
        {
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken,
          },
          withCredentials: true,
        }
      );
      setSelectedChoices((prev) =>
        prev.filter(
          (choice) =>
            !(String(choice.COLL_CODE) === COLL_CODE && String(choice.BRANCH) === BRANCH)
        )
      );
      setLoading(false)
      setModalType({
        icon: 'success',
        title: 'Deleted Successfully',
        text: `The choice <b style="font-weight:900">${COLL_CODE} - ${BRANCH}</b> was deleted successfully.`,
      });
      setShowCancelButton(false);
      setOnConfirm(() => closeModal);
      setOnCancel(() => () => { });
      openModal();
    } catch (error) {
      console.error('Error removing choice:', error);
      closeModal();
      setModalType({
        icon: 'error',
        title: 'Removal Failed',
        text: 'Something went wrong while removing your choice.',
      });
      setShowCancelButton(false);
      setOnConfirm(() => closeModal);
      setOnCancel(() => () => { });
      openModal();
    }
    finally {
      setPendingChoice(null);
    }
  };

  const moveChoice = (index, direction) => {
    setSelectedChoices(prev => {
      const newChoices = [...prev];
      const [movedChoice] = newChoices.splice(index, 1);
      newChoices.splice(index + direction, 0, movedChoice);
      return newChoices;
    });
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };


  const handleDataSearch = async () => {
    setLoading(true);
    setError(null);
    // console.log(Object.values(filterData))
    if (!selectedCollege && !selectedDept && !selectedDist && !Object.values(filterData).some(Boolean)) {
      // console.log("not selected")
      setError('Please select at least one search criteria');
      fetchData();
      setLoading(false);
      return;
    }
    else {
      setPage(1)
    }
    try {
      const response = await axios.post(
        `${serverUrl}/api/choicefilling/user/choices/search`,
        {
          college: selectedCollege,
          dept: selectedDept,
          district: selectedDist,
          filter: filterData,
          retrieveWomensCollege: localStorage.getItem('sex') != "Male"
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken,
          },
          withCredentials: true,
        }
      );
      if (response.data && response.data.data) {
        setData(response.data.data);
        setTotalPages(1);
      } else {
        setData([])
        setTotalPages(1);
      }
    } catch (error) {
      setError(error.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handleClearFilter = () => {
    setFilterData({
      university: false,
      government: false,
      governmentAided: false,
      cipetCsir: false,
      womenColleges: false,
      selfFinanceColleges: false
    });
    setSelectedCollege('');
    setSelectedDept('');
    setSelectedDist('');

    setClearFilter(true)
  };
  useEffect(() => {
    if (clearFilter) {
      setTimeout(() => {
        handleDataSearch();
        setClearFilter(false);
      }, 0);
    }
  }, [clearFilter]);



  useEffect(() => {
    if (searchQuery === '') {
      setFilteredData(data);  // If no search query, show all data
    } else {
      const filtered = data.filter((row) => {
        // Get the branch name from the BRANCH code
        const branchName = BRANCH.get(row.BRANCH) || '';

        // Convert the query and fields to lower case (ensure they're strings)
        const queryLowerCase = searchQuery.toLowerCase();
        const collCode = String(row.COLL_CODE).toLowerCase();  // Ensure COLL_CODE is treated as a string
        const institution = String(row.INSTITUTION).toLowerCase();  // Ensure INSTITUTION is treated as a string
        const branchNameLowerCase = branchName.toLowerCase();  // Branch name should also be a string

        // Filter records that match the query in any of the fields
        return (
          collCode.includes(queryLowerCase) ||
          institution.includes(queryLowerCase) ||
          branchNameLowerCase.includes(queryLowerCase)
        );
      });
      setFilteredData(filtered);
    }
  }, [searchQuery, data]); // Re-run filter when data or search query changes


  useEffect(() => {
    const fetchNecessaryData = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/choicefilling/user/choices/necessaryData`, {
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken,
          },
          withCredentials: true,
        });
        setColleges(response.data.colleges);
        setDepts(response.data.departments);
        setDist(response.data.districts);
      } catch (error) {
        console.error('Error fetching necessary data:', error);
      }
    };
    fetchNecessaryData();
  }, [csrfToken]);

  return (
    <>

      <div className="choice-table-container">
        <div className='choicefilling-header'>
          <h1>Institution Data</h1>

          <button
            type="submit"
            className="button button-primary-choice clear-filter" onClick={handleClearFilter}
          >Clear Filter</button>
        </div>


        <div className="search-form-item">
          <label htmlFor="" style={{ marginBottom: '5px' }}>
            Search By College
          </label>
          <select value={selectedCollege} onChange={handleCollegeChange}>
            <option value=""> --- Select --- </option>
            {colleges.map((college, index) => (
              <option key={index} value={college.COLL_CODE}>
                {college.COLL_CODE} - {college.INSTITUTION}
              </option>
            ))}
          </select>
        </div>
        <div className="search-form-item">
          <label htmlFor="" style={{ marginBottom: '5px' }}>
            Search By Department
          </label>
          <select value={selectedDept} onChange={handleDeptChange}>
            <option value=""> --- Select --- </option>
            {depts.map((branch, index) => (
              <option key={index} value={branch.BRANCH}>
                {BRANCH.get(branch.BRANCH)} --- {branch.BRANCH}
              </option>
            ))}
          </select>
        </div>
        <div className="search-form-item">
          <label htmlFor="" style={{ marginBottom: '5px' }}>
            Search By District
          </label>
          <select value={selectedDist} onChange={handleDistChange}>
            <option value=""> --- Select --- </option>
            {dist.map((district, index) => (
              <option key={index} value={district.DISTRICT}>
                {district.DISTRICT}
              </option>
            ))}
          </select>
        </div>
        <div
          style={{
            margin: '3% 0',
            display: 'flex',
            justifyContent: 'space-around',
            textAlign: 'center',
            flexWrap: 'wrap',
          }}
        >
          <label style={{ marginBottom: '3%' }}>
            <input
              type="checkbox"
              name="university"
              checked={filterData.university}
              onChange={handleFilter}
            />
            University
          </label>
          <label>
            <input
              type="checkbox"
              name="government"
              checked={filterData.government}
              onChange={handleFilter}
            />
            Government
          </label>
          <label>
            <input
              type="checkbox"
              name="governmentAided"
              checked={filterData.governmentAided}
              onChange={handleFilter}
            />
            Government Aided
          </label>

          <label>
            <input
              type="checkbox"
              name="womenColleges"
              checked={filterData.womenColleges}
              onChange={handleFilter}
            />
            Women Colleges
          </label>
          <label>
            <input
              type="checkbox"
              name="cipetCsir"
              checked={filterData.cipetCsir}
              onChange={handleFilter}
            />
            CIPET / CSIR
          </label>
          <label>
            <input
              type="checkbox"
              name="selfFinanceColleges"
              checked={filterData.selfFinanceColleges}
              onChange={handleFilter}
            />
            Self-Finance Colleges
          </label>
        </div>
        <div className="search-btn">
          <button id='choicefilling-search-btn' onClick={handleDataSearch}>Search</button>
        </div>
        {error && <div>Error: {error}</div>}
        <div style={{
          marginBottom: '20px',
          display: 'flex',

        }}>
          <div className="search-container">
            <div className="search-input-group">
              <label className="filter-label">
                Filter By
              </label>
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearch}
                placeholder="Filter by COLL_CODE, INSTITUTION, or BRANCH"
                className="search-input"
              />
            </div>

            <button
              type="submit"
              className="button button-primary-choice" onClick={hanleSelectedChoices}
            >View Selected Choice List</button>
          </div>


        </div>
        {
          loading ? (<Loader />) : (
            <table className="choice-responsive-table">
              <thead>
                <tr>
                  <th>S No.</th>
                  <th>Select</th>
                  <th>College Code</th>
                  <th>Institution Name</th>
                  <th>Branch</th>
                  {community !== 'OC' && <th>OC</th>}
                  {community === 'SCA' && (<th>SCA</th>) }
                  {community === 'SCA' && (<th>SC</th>) }
                  {/* {community === 'SC' && (<th>SCA</th>)} */}
                  {community!='SCA' && (<th>{community}</th>)}
                </tr>
              </thead>

              <tbody>
                {
                  (!(filteredData.length === 0 && searchQuery)) &&
                  (
                    filteredData.map((row, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedChoices.some(
                              (choice) =>
                                String(choice.COLL_CODE) === String(row.COLL_CODE) &&
                                String(choice.BRANCH) === String(row.BRANCH)
                            )}
                            disabled={
                              // community === 'SC' && row['SCA'] === 0
                              community === 'OC' ? (row['OC'] === 0) : community === 'SCA' ? (row['OC'] === 0 && row[community] === 0 && row['SC'] === 0) : (row['OC'] === 0 && row[community] === 0)
                            }

                            style={{ cursor: community === 'OC' ? (row['OC'] === 0) : community === 'SCA' ? (row['OC'] === 0 && row[community] === 0 && row['SC'] === 0) : (row['OC'] === 0 && row[community] === 0) 
                              ? 'not-allowed' : 'pointer' }}

                            onChange={() => handleCheckbox(String(row.COLL_CODE), String(row.BRANCH))}
                          />
                        </td>
                        <td>{row.COLL_CODE}</td>
                        <td>{row.INSTITUTION}</td>

                        <td>{BRANCH.get(row.BRANCH)}</td>
                        {community !== 'OC' && <td style={{ color: row.OC > 0 ? `#28a745` : `#cf352e`, fontWeight: 550 }}>{row.OC}</td>}
                        {/* {community === 'SC' && (<td style={{ color: row['SCA'] > 0 ? `#28a745` : `#cf352e`, fontWeight: 550 }}>{row.SCA}</td>)} */}
                        {community === 'SCA' && (<td style={{ color: row['SCA'] > 0 ? `#28a745` : `#cf352e`, fontWeight: 550 }}>{row.SCA}</td>)}
                        {community === 'SCA' && (<td style={{ color: row['SC'] > 0 ? `#28a745` : `#cf352e`, fontWeight: 550 }}>{row.SC}</td>)}
                        {community !== 'SCA' && (<td style={{ color: row[community] > 0 ? `#28a745` : `#cf352e`, fontWeight: 550 }}>{row[community]}</td>)}
                        
                      </tr>
                    ))
                  )
                }
              </tbody>

            </table>
            // <table className="choice-responsive-table">
            //   <thead>
            //     <tr>
            //       <th>S No.</th>
            //       <th>Select</th>
            //       <th>College Code</th>
            //       <th>Institution Name</th>
            //       <th>Branch</th>
            //       {community !== 'OC' && <th>OC</th>}
            //       {community === 'SCA' && (<th>SC</th>)}
            //       <th>{community}</th>
            //     </tr>
            //   </thead>

            //   <tbody>
            //     {
            //       (!(filteredData.length === 0 && searchQuery)) &&
            //       (
            //         filteredData.map((row, index) => (
            //           <tr key={index}>
            //             <td>{index + 1}</td>
            //             <td>
            //               <input
            //                 type="checkbox"
            //                 checked={selectedChoices.some(
            //                   (choice) =>
            //                     String(choice.COLL_CODE) === String(row.COLL_CODE) &&
            //                     String(choice.BRANCH) === String(row.BRANCH)
            //                 )}
            //                 disabled={
            //                   community === 'OC' ? (row['OC'] === 0) : community === 'SCA' ? (row['OC'] === 0 && row[community] === 0 && row['SC'] === 0) : (row['OC'] === 0 && row[community] === 0)
            //                 }

            //                 style={{ cursor: (community === 'OC' ? (row['OC'] === 0) : community === 'SCA' ? (row['OC'] === 0 && row[community] === 0 && row['SC'] === 0) : (row['OC'] === 0 && row[community] === 0)) ? 'not-allowed' : 'pointer' }}

            //                 onChange={() => handleCheckbox(String(row.COLL_CODE), String(row.BRANCH))}
            //               />
            //             </td>
            //             <td>{row.COLL_CODE}</td>
            //             <td>{row.INSTITUTION}</td>

            //             <td>{BRANCH.get(row.BRANCH)}</td>
            //             {community !== 'OC' && <td style={{ color: row.OC > 0 ? `#28a745` : `#cf352e`, fontWeight: 550 }}>{row.OC}</td>}
            //             {community === 'SCA' && (<td style={{ color: row['SC'] > 0 ? `#28a745` : `#cf352e`, fontWeight: 550 }}>{row.SC}</td>)}
            //             <td style={{ color: row[community] > 0 ? `#28a745` : `#cf352e`, fontWeight: 550 }}>{row[community]}</td>
            //           </tr>
            //         ))
            //       )
            //     }
            //   </tbody>

            // </table>

          )


        }
        {
          (data.length !== 0 && filteredData.length === 0 && searchQuery) &&
          (

            <p className='no-result'>No Choices Available in this page</p>

          )}

        {
          (data.length === 0 && totalPages == 1) &&
          (

            <p className='no-result'>No Choices Available for your specific filteration</p>

          )}

        <div className="pagination">
          <button onClick={() => handlePageChange(page - 1)} disabled={page === 1 || loading}>
            <img src={prevIcon} width={15} height={15} alt="Back" />
          </button>
          <span>
            {page} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(page + 1)}
            disabled={page === totalPages || loading}
          >
            <img src={nextIcon} width={15} height={15} alt="Next" />
          </button>
        </div>

      </div>

      {/* <h2>Selected Choices</h2>
      <ul> */}
      {/* {selectedChoices.map((choice, index) => (
          <li key={index}>
            {choice.COLL_CODE} - {BRANCH.get(choice.BRANCH)}
            <button onClick={() => moveChoice(index, -1)} disabled={index === 0}>
              ↑
            </button>
            <button
              onClick={() => moveChoice(index, 1)}
              disabled={index === selectedChoices.length - 1}
            >
              ↓
            </button>
          </li>
        ))} */}
      {/* </ul> */}
      <PopModal
        isOpen={isModalOpen}
        type={modalType}
        confirmButtonText={modalType.icon === 'success' || modalType.icon === 'error' || modalType.icon === 'info' ? 'OK' : 'Yes'}
        cancelButtonText="No"
        onConfirm={onConfirm}
        onCancel={showCancelButton ? onCancel : null}
        showCancelButton={showCancelButton}
      />
    </>
  );
}

export default Choicefilling;
